// @ts-nocheck
import { hubService, workerService, } from '@/services';
export default {
    setWorkerSettingDialogOpen({ commit }, isOpen = true) {
        commit('SET_WORKER_SETTING_DIALOG_OPEN', isOpen);
    },
    setSelectedSettingGroup({ commit }, group) {
        commit('SET_SELECTED_SETTING_GROUP', group);
    },
    setFilterOption({ commit }, payload) {
        commit('SET_FILTER_OPTION', payload);
    },
    setFeeGroupRegisterList({ state, commit }, register) {
        const isOriginHasRegister = state.feeGroupWorkerList.some((worker) => worker.code === register.code);
        const unregisterList = state.unregisterList
            .filter((unregister) => unregister !== register);
        commit('SET_FEE_GROUP_UNREGISTER_LIST', unregisterList);
        if (isOriginHasRegister) {
            commit('SET_FEE_GROUP_REGISTER_LIST', state.registerList);
            return;
        }
        const registerList = state.registerList.concat(register);
        commit('SET_FEE_GROUP_REGISTER_LIST', registerList);
    },
    setFeeGroupUnregisterList({ state, commit }, unregister) {
        const isOriginHasUnregister = state.feeGroupAvailableWorkerList.some((worker) => worker.code === unregister.code);
        const registerList = state.registerList
            .filter((register) => register !== unregister);
        commit('SET_FEE_GROUP_REGISTER_LIST', registerList);
        if (isOriginHasUnregister) {
            commit('SET_FEE_GROUP_UNREGISTER_LIST', state.unregisterList);
            return;
        }
        const unregisterList = state.unregisterList.concat(unregister);
        commit('SET_FEE_GROUP_UNREGISTER_LIST', unregisterList);
    },
    /**
     * 라이더 관리 배달대행료 수수료 그룹 라이더 등록
     * @param {object} payload
     * @param {number} payload.groupId 라이더를 추가 혹은 삭제할 그룹.
     * @param {string[]} [payload.registers] 추가할 라이더 목록.
     * @param {string[]} [payload.unregisters] 삭제할 라이더 목록.
     */
    async postWorkerDeliveryFeeGroupRegister({ commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '' } = payload;
        const response = await hubService.postWorkerDeliveryFeeGroupRegister({
            hubId,
            groupId,
            payload,
        });
        commit('POST_WORKER_DELIVERY_FEE_GROUP_REGISTER', response.isSuccess);
    },
    /**
     * 라이더 관리 배달대행료 수수료 그룹 라이더 목록 조회
     * @param {object} payload
     * @param {number} payload.groupId 라이더를 추가 혹은 삭제할 그룹.
     */
    async getFeeGroupWorkerList({ commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '' } = payload;
        const response = await workerService.getFeeGroupWorkerList({
            hubId,
            groupId,
        });
        commit('GET_FEE_GROUP_WORKER_LIST', response.data?.list);
    },
    /**
     * 라이더 관리 배달대행료 수수료 그룹 등록 가능한 라이더 목록 조회
     * @param {object} payload
     * @param {number} payload.groupId 라이더를 추가 혹은 삭제할 그룹.
     */
    async getFeeGroupAvailableWorkerList({ commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '' } = payload;
        const response = await workerService.getFeeGroupAvailableWorkerList({
            hubId,
            groupId,
        });
        commit('GET_FEE_GROUP_AVAILABLE_WORKER_LIST', response.data?.list);
    },
    clearDialogInfo({ commit }) {
        commit('CLEAR_SELECTED_SETTING_GROUP');
        commit('CLEAR_FEE_GROUP_WORKER_LIST');
        commit('CLEAR_FEE_GROUP_AVAILABLE_WORKER_LIST');
        commit('CLEAR_FEE_GROUP_REGISTER_LIST');
    },
    clearSelectedSettingGroup({ commit }) {
        commit('CLEAR_SELECTED_SETTING_GROUP');
    },
    clearFeeGroupWorkerList({ commit }) {
        commit('CLEAR_FEE_GROUP_WORKER_LIST');
    },
    clearFeeGroupAvailableWorkerList({ commit }) {
        commit('CLEAR_FEE_GROUP_AVAILABLE_WORKER_LIST');
    },
    clearFeeGroupRegisterList({ commit }) {
        commit('CLEAR_FEE_GROUP_REGISTER_LIST');
    },
};
